export default function () {
  const dateInput = document.querySelector('input[type="date"]');

  if (dateInput) {
    dateInput.max = new Date().toISOString().split("T")[0];
  }
}
